<template>
	<section id="contacto">
		<h2>Contacto</h2>
		<p>Si quieres contactar conmigo para trabajo o cualquier otro asunto, puedes usar el siguiente correo electrónico o numero de teléfono</p>

		<h3>Alejandromzv18@gmail.com</h3>
		<h3>+58 414 664 0135</h3>
	</section>
</template>

<style scoped>
section {
	background-color: #333399;
	color: white;
	height: 500px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

h2 {
	padding: 1em;
	text-align: center;
}

p {
	padding: 1em;
	text-align: center;
}

h3 {
	text-align: center;
	background-color: #333399;
}
</style>